import { VOLTAGE } from '../constants';
var isVoltageAttribute = function isVoltageAttribute(type) {
  return type === VOLTAGE;
};
export default isVoltageAttribute;